$(function () {

    $('.navbar-sliding-indicators .list-link').on('mouseover', function() {
        $this = $(this);
        var position = $this.parent().position();
        var height = $this.parent().height();
        
        $this
            .closest('.navbar-sliding-indicators')
            .find('.nav-indicator')
            .css({
                opacity: 1,
                top: +position.top,
                height: height
        });
        $this
            .addClass('is-current');
    });


    $('.navbar-sliding-indicators .list-link').on('mouseout', function() {
        $this = $(this);

        $('.navbar-sliding-indicators .list-link')
            .removeClass('is-current');
    });


    $('.navbar-sliding-indicators').on('mouseout', function() {
        $this = $(this);

        $this
            .closest('.navbar-sliding-indicators')
            .find('.nav-indicator')
            .css({
                opacity: 0,
        });
    });


    $('.navbar-sliding-indicators .nav-indicator').each(function() {
        $this = $(this);

        var currentHeight = $this
            .closest('.navbar-sliding-indicators')
            .find('li:nth-of-type(1) .list-link')
            .parent('.nav-item')
            .height();

        var current = $this
            .closest('.navbar-sliding-indicators')
            .find('li:nth-of-type(1) .list-link')
            .position();

        $this.css({
            top: +current.top,
            height: currentHeight
        });
    });
});
